import { jsx, Fragment, jsxs } from 'react/jsx-runtime';
import { useEffect } from 'react';
import { Transition } from '@headlessui/react';
import { SfCloseCrossLargeIcon, SfCheckmarkCircleFillIcon, SfExclamationmarkTriangleFillIcon, SfMinusCircleFillIcon, SfQuestionmarkCircleFillIcon } from '@ninja/icons/web';
import styles from './Toast4.js';

const icons = {
    success: SfCheckmarkCircleFillIcon,
    warning: SfExclamationmarkTriangleFillIcon,
    error: SfMinusCircleFillIcon,
    info: SfQuestionmarkCircleFillIcon,
};
/** A simple toast component with an message,
 *  and dismissible close button to show alert messages to your website visitors. */
const Toast = ({ title = '', severity, description, duration = 3000, position = 'top-center', closeToast, isShown, icon, isClosable = false, className = '', }) => {
    useEffect(() => {
        const time = setTimeout(() => {
            if (isShown)
                closeToast();
        }, duration);
        return () => {
            clearTimeout(time);
        };
    }, [isShown]);
    if (!isShown)
        return jsx(Fragment, {});
    const ToastIcon = icon !== null && icon !== void 0 ? icon : icons[severity];
    return (jsx(Transition, { appear: true, show: isShown, enter: "transition-all duration-150", enterFrom: "opacity-0 scale-50", enterTo: "opacity-100 scale-100 z-50", leave: "transition-all duration-150", leaveFrom: "opacity-100 scale-100", leaveTo: "opacity-0 scale-50", children: jsx("div", { className: styles.toastTransitionContainer(position, className), children: jsxs("div", { className: styles.toastContainer(severity), children: [jsxs("div", { className: styles.toastInnerContainer, children: [!!ToastIcon && jsx(ToastIcon, { className: styles.toastIcon }), jsxs("div", { className: styles.toastTextContainer, children: [jsx("h4", { className: styles.toastTitle, children: title }), description && jsx("p", { className: styles.toastDescription, children: description })] })] }), isClosable && jsx(SfCloseCrossLargeIcon, { className: styles.toastCloseIcon, onClick: () => closeToast() })] }) }) }));
};

export { Toast };
